module.exports = __webpack_public_path__ + "img/store-woocommerce.4c2ecb16.svg";